const API_BASE_URL = process.env.REACT_APP_API_URL;
const PERSONAL_INFO_ENDPOINT = `${API_BASE_URL}info-personal`;

export const createPersonalInfo = async (data) => {
  try {
    // Preparar los datos para envío
    const dataToSend = {
      ...data,
      cargoId: data.cargoId && data.cargoId !== '' ? parseInt(data.cargoId, 10) : null
    };

    const response = await fetch(PERSONAL_INFO_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataToSend),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error en la petición:', response.status, errorData);
      return { success: false, message: errorData.message || `Error del servidor: ${response.status}` };
    }

    const responseData = await response.json();
    
    if (responseData && responseData.tokenTemporal) {
      localStorage.setItem('tempAuthToken', responseData.tokenTemporal);
      return { success: true, data: responseData };
    } else {
      console.error('Token temporal no encontrado en la respuesta');
      return { success: false, message: 'Token temporal no fue recibido.' };
    }

  } catch (error) {
    console.error('Error al enviar la información personal:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 